import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Body } from './cse.body';
import { InicioComponent } from './component/inicio.component';
import { DashboardComponent } from './component/dashboard.component';

import { AuthGuard } from './services/auth-guard.service';

import { LoginComponent } from 'app/view/login/login.component';
import { MenuComponent } from 'app/view/menu/menu.component';
import { ImpoComponent } from 'app/view/impo/impo.component';
import { ExpoComponent } from 'app/view/expo/expo.component';

const routes: Routes = [
    { path: '', redirectTo: 'iniciar-sesion', pathMatch: 'full' },
    { path: 'iniciar-sesion', component: LoginComponent },
    { path: 'menu', component: MenuComponent, canActivate: [AuthGuard] },
    {
        path: 'inicio', component: InicioComponent, canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {
                    breadcrumb: "Dashboard"
                }
            },
            {
                path: 'impo', component: ImpoComponent, canActivate: [AuthGuard], data: {
                    breadcrumb: "Impo Devolucion / Buscar BL"
                }
            },
            {
                path: 'expo', component: ExpoComponent, canActivate: [AuthGuard], data: {
                    breadcrumb: "Expo Retiro / Buscar Booking"
                }
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})

export class AppRoutingModule { }

export const routedComponents = [Body,
    LoginComponent,
    MenuComponent,
    InicioComponent,
    ImpoComponent,
    ExpoComponent
];


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/cse.routing.ts